import apiClient from './apiClient';

const baseUrl = '/api/supplier/tenant-vs-category';

const tenantVsCategoryService = {
  getMyCategories() {
    return apiClient.get(`${baseUrl}/my-categories`).then((response) => response.data);
  },

  updateMyCategories(materialCategoryIds) {
    return apiClient
      .put(`${baseUrl}/my-categories`, {
        materialCategoryIds: Array.isArray(materialCategoryIds) ? materialCategoryIds : []
      })
      .then((response) => response.data);
  },

  searchTenantCategories(params = {}) {
    const requestBody = {
      page: params.page ?? 0,
      pageSize: params.pageSize ?? 100,
      tenantId: params.tenantId || null,
      searchText: params.searchText || ''
    };
    return apiClient.post(`${baseUrl}/search`, requestBody).then((response) => response.data);
  },

  /**
   * Demand figures for the Categories screen: how many of the requests this supplier
   * received in the window fell inside its categories, and which unselected categories
   * are in demand. `days` is clamped server-side.
   */
  getCategoryInsights(days = 30) {
    return apiClient
      .get(`${baseUrl}/category-insights`, { params: { days } })
      .then((response) => response.data);
  },

  getTenantCategories(tenantId) {
    if (!tenantId) {
      return Promise.reject(new Error('Tenant ID is required'));
    }
    return apiClient.get(`${baseUrl}/tenant/${tenantId}`).then((response) => response.data);
  }
};

export default tenantVsCategoryService;
